import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6a4ffacb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex-desktop" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "ion-float-right" }
const _hoisted_4 = { class: "dark" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Total Visitors", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Entered", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Date and time", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Location", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "About this event", -1))
const _hoisted_10 = ["innerHTML"]

import { share, calendar, location, pencil } from "ionicons/icons";
import { useAppStore } from "@/stores/app";
import { useContextStore } from "@/stores/context";
import { computed } from "vue";

import {
  IonIcon,
  IonContent,
  IonPage,
  IonGrid,
  IonLabel,
  IonItem,
  IonRow,
  IonCol,
} from "@ionic/vue";
import EventSidebar from "@/views/_partials/EventSidebar.vue";
import useDates from "@/composition/dates";
import { useWindowWidth } from "@/composition/window";

import router from "@/router";


export default /*#__PURE__*/_defineComponent({
  __name: 'Home',
  setup(__props) {

const { isMobile } = useWindowWidth();
const contextStore = useContextStore();
const appStore = useAppStore();

const dates = useDates();
const seeVisitors = (type: string) => {
  switch (type) {
    case "all":
      router.push(`/event/${contextStore.event.id}/visitors`);
      break;
    case "checked-in":
      router.push(`/event/${contextStore.event.id}/visitors/checkedin`);
      break;
    default:
      router.push(`/event/${contextStore.event.id}/visitors`);
  }
};

const dark_mode = computed(() => appStore.settings.theme === "dark");


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonContent), null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            (!_unref(isMobile))
              ? (_openBlock(), _createBlock(EventSidebar, {
                  key: 0,
                  event: _unref(contextStore).event
                }, null, 8, ["event"]))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: _normalizeClass(dark_mode.value ? 'full-width' : 'colored-bg full-width')
            }, [
              _createElementVNode("section", {
                class: _normalizeClass(dark_mode.value ? 'dark_mode' : '')
              }, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("h1", null, [
                    _createTextVNode(_toDisplayString(_unref(contextStore).event.name) + " ", 1),
                    _createVNode(_component_router_link, {
                      style: {"color":"var(--color)"},
                      to: `/event/${_unref(contextStore).event.id}/settings`
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("small", null, [
                          _createVNode(_unref(IonIcon), {
                            icon: _unref(pencil),
                            class: "ion-float-right"
                          }, null, 8, ["icon"])
                        ])
                      ]),
                      _: 1
                    }, 8, ["to"])
                  ]),
                  _createElementVNode("h4", null, [
                    _createTextVNode(" Attendance Status: "),
                    _createElementVNode("b", _hoisted_3, _toDisplayString(_unref(contextStore).event.checked_in_visitors > 0
                      ? Math.round(
                          (_unref(contextStore).event.checked_in_visitors /
                            _unref(contextStore).event.registered_visitors) *
                            100
                        )
                      : 0) + "%", 1)
                  ]),
                  _createVNode(_unref(IonGrid), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonRow), null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonCol), null, {
                            default: _withCtx(() => [
                              _createElementVNode("div", {
                                class: "box ion-margin-bottom clickable",
                                onClick: _cache[0] || (_cache[0] = ($event: any) => (seeVisitors('all')))
                              }, [
                                _createElementVNode("h1", _hoisted_4, _toDisplayString(_unref(contextStore).event.registered_visitors), 1)
                              ]),
                              _hoisted_5
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(IonCol), null, {
                            default: _withCtx(() => [
                              _createElementVNode("div", {
                                class: "box is-success ion-margin-bottom clickable",
                                onClick: _cache[1] || (_cache[1] = ($event: any) => (seeVisitors('checked-in')))
                              }, [
                                _createElementVNode("h1", null, _toDisplayString(_unref(contextStore).event.checked_in_visitors), 1)
                              ]),
                              _hoisted_6
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createElementVNode("h4", null, [
                    _createTextVNode("When and where "),
                    _createVNode(_unref(IonIcon), { icon: _unref(share) }, null, 8, ["icon"])
                  ]),
                  _createVNode(_unref(IonItem), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonIcon), { icon: _unref(calendar) }, null, 8, ["icon"]),
                      _createVNode(_unref(IonLabel), null, {
                        default: _withCtx(() => [
                          _hoisted_7,
                          _createElementVNode("p", null, " Starts at " + _toDisplayString(_unref(dates).getDateWithTime(_unref(contextStore).event.start_date)), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(IonItem), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonIcon), { icon: _unref(location) }, null, 8, ["icon"]),
                      _createVNode(_unref(IonLabel), null, {
                        default: _withCtx(() => [
                          _hoisted_8,
                          _createElementVNode("p", null, _toDisplayString(_unref(contextStore).event.location), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  (_unref(contextStore).event.description !== '')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _hoisted_9,
                        _createElementVNode("p", {
                          innerHTML: _unref(contextStore).event.description
                        }, null, 8, _hoisted_10)
                      ], 64))
                    : _createCommentVNode("", true)
                ])
              ], 2)
            ], 2)
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})